import React, { useEffect, useState } from "react";

import './RetirementAge.css';
import { postHeightToParent } from '../common-helpers';

import { Button } from "../Button";
import { TextInput } from "../TextInput";
import { Result } from "../Result";

export const RetirementAge: React.FC = () => {
  const [year, setYear] = useState("");
  const [age, setAge] = useState("");
  const [msg, setMsg] = useState("");

  const resetCalc = () => {
    const birthYearInput = document.getElementById("birth-year") as HTMLInputElement;
    birthYearInput.focus();

    setYear("");
    setAge("");
    setMsg("");
  };

  const updateCalc = (userInput: string) => {
    const currentYear = new Date().getFullYear();
    const userInputNum: number = parseInt(userInput, 10);
    setMsg("");
    setAge("");

    if (isNaN(userInputNum) || userInput.length > 4) {
      setMsg("You must enter your 4 digit birth year");
    } else {
      if (userInput.length === 4) {
        if (userInputNum > currentYear) {
          setMsg("Please enter a valid birth year");
        } else {
          setAge(calculate(userInputNum));
        }
      }
    }
  };

  const calculate = (birthYear: number) => {
    let result = '';
    switch(true) {
      case birthYear<=1937:
        result = '65';
        break;
      case birthYear===1938:
        result = '65 and 2 months';
        break;
      case birthYear===1939:
        result = '65 and 4 months';
        break;
      case birthYear===1940:
        result = '65 and 6 months';
        break;
      case birthYear===1941:
        result = '65 and 8 months';
        break;
      case birthYear===1942:
        result = '65 and 10 months';
        break;
      case birthYear>=1943 && birthYear<=1954:
        result = '66';
        break;
      case birthYear===1955:
        result = '66 and 2 months';
        break;
      case birthYear===1956:
        result = '66 and 4 months';
        break;
      case birthYear===1957:
        result = '66 and 6 months';
        break;
      case birthYear===1958:
        result = '66 and 8 months';
        break;
      case birthYear===1959:
        result = '66 and 10 months';
        break;
      case birthYear>=1960:
        result = '67';
        break;
      default:
        result = '';
        break;
    }

    return result;
  }

  useEffect(() => {
    postHeightToParent(document.body.scrollHeight);
  }, [age]);

  return (
  	<div className="retirement-age-widget">
  		<div className="title-section">
  			<p>When is your FULL retirement age?</p><p>It depends on the year you were born.</p>
  		</div>
  		<div className="content-section">
  			<div className="input-section">
  				<p>Enter your 4-digit birth year below:</p>
          <div className="input-area">
  				<TextInput
            name="birthYear"
            inputMode="numeric"
  					id="birth-year"
            fieldClass="input--start-over-field"
            value={year}
            onChange = {(event: React.ChangeEvent<HTMLInputElement>) => {
              const userInputValue = event.target.value;
              updateCalc(userInputValue);
              setYear(userInputValue);
            }}
            data-testid="birth-year"
  				/>
            <label
              htmlFor="birth-year"
              className="input--start-over-label"
            >
              Birth Year
            </label>
          </div>
        </div>
        <div className="result-section">
          <p>Your full retirement age is:</p>

          { msg ?
            <p className="error-msg">{msg}</p>

            : <Result id="result" result={age} />
          }
        </div>
      </div>
      <Button
        label="Start Over"
        className="primary-button"
        onClickHandler={ () => resetCalc() }
      />
    </div>
  );
}
